 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"error-404-vue":"error-404-vue","examples-source":"examples-source","layout-locale-index-vue":"layout-locale-index-vue","layout-wireframe-index-vue":"layout-wireframe-index-vue","locale-fr-FR-json":"locale-fr-FR-json","locale-ja-json":"locale-ja-json","locale-zh-Hans-json":"locale-zh-Hans-json","views-Documentation":"views-Documentation","views-Home":"views-Home","views-Wireframes":"views-Wireframes","vuetify~examples~layout-default-index-vue~layout-home-index-vue":"vuetify~examples~layout-default-index-vue~layout-home-index-vue","vuetify~examples~layout-default-index-vue":"vuetify~examples~layout-default-index-vue","vendors~layout-default-index-vue~layout-home-index-vue":"vendors~layout-default-index-vue~layout-home-index-vue","layout-default-index-vue~layout-home-index-vue":"layout-default-index-vue~layout-home-index-vue","layout-default-index-vue":"layout-default-index-vue","vuetify~examples~layout-home-index-vue":"vuetify~examples~layout-home-index-vue","vuetify~examples":"vuetify~examples","vendors~examples":"vendors~examples","examples":"examples","layout-home-index-vue":"layout-home-index-vue","webfontloader":"webfontloader","api-en-js":"api-en-js","api-ja-js":"api-ja-js","api-zh-Hans-js":"api-zh-Hans-js","documentation-en-js":"documentation-en-js","documentation-fr-FR-js":"documentation-fr-FR-js","documentation-ja-js":"documentation-ja-js","documentation-zh-Hans-js":"documentation-zh-Hans-js","home-page-en-home-md":"home-page-en-home-md","home-page-fr-FR-home-md":"home-page-fr-FR-home-md","home-page-ja-home-md":"home-page-ja-home-md","home-page-zh-Hans-home-md":"home-page-zh-Hans-home-md","wireframes-view-en-getting-started-wireframes-md":"wireframes-view-en-getting-started-wireframes-md","wireframes-view-fr-FR-getting-started-wireframes-md":"wireframes-view-fr-FR-getting-started-wireframes-md","wireframes-view-ja-getting-started-wireframes-md":"wireframes-view-ja-getting-started-wireframes-md","wireframes-view-zh-Hans-getting-started-wireframes-md":"wireframes-view-zh-Hans-getting-started-wireframes-md","api-pages-en-pages-json":"api-pages-en-pages-json","api-pages-ja-pages-json":"api-pages-ja-pages-json","api-pages-zh-Hans-pages-json":"api-pages-zh-Hans-pages-json","locale-pages-en-pages":"locale-pages-en-pages","locale-pages-fr-FR-pages":"locale-pages-fr-FR-pages","locale-pages-ja-pages":"locale-pages-ja-pages","locale-pages-zh-Hans-pages":"locale-pages-zh-Hans-pages"}[chunkId]||chunkId) + "." + {"error-404-vue":"90ea2d78","examples-source":"613ad28e","layout-locale-index-vue":"bd9049e4","layout-wireframe-index-vue":"a8068339","locale-fr-FR-json":"339216f9","locale-ja-json":"2929b96d","locale-zh-Hans-json":"6be9f76c","views-Documentation":"e40078bf","views-Home":"aea0138a","views-Wireframes":"d60f7799","vuetify~examples~layout-default-index-vue~layout-home-index-vue":"93114253","vuetify~examples~layout-default-index-vue":"f566f3d5","vendors~layout-default-index-vue~layout-home-index-vue":"88c87263","layout-default-index-vue~layout-home-index-vue":"e632d96c","layout-default-index-vue":"22e26585","vuetify~examples~layout-home-index-vue":"dcd5355f","vuetify~examples":"5cd00ab3","vendors~examples":"35650889","examples":"cf8ecb4d","layout-home-index-vue":"8a46163d","webfontloader":"95910588","api-en-js":"10e83826","api-ja-js":"09da4d00","api-zh-Hans-js":"7402412b","documentation-en-js":"15431865","documentation-fr-FR-js":"3edf020f","documentation-ja-js":"1d66fad0","documentation-zh-Hans-js":"efcf5df9","home-page-en-home-md":"bf223686","home-page-fr-FR-home-md":"602185f8","home-page-ja-home-md":"6b5b7347","home-page-zh-Hans-home-md":"e85fbbdc","wireframes-view-en-getting-started-wireframes-md":"7c933466","wireframes-view-fr-FR-getting-started-wireframes-md":"ea80c1de","wireframes-view-ja-getting-started-wireframes-md":"820226ee","wireframes-view-zh-Hans-getting-started-wireframes-md":"d2ce1e1b","api-pages-en-pages-json":"85417325","api-pages-ja-pages-json":"27d9d7f8","api-pages-zh-Hans-pages-json":"116ce4d7","locale-pages-en-pages":"fd983cf1","locale-pages-fr-FR-pages":"34f70da3","locale-pages-ja-pages":"2b26d41b","locale-pages-zh-Hans-pages":"31bdf7e7"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"layout-locale-index-vue":1,"views-Home":1,"layout-default-index-vue~layout-home-index-vue":1,"layout-default-index-vue":1,"examples":1,"layout-home-index-vue":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"error-404-vue":"error-404-vue","examples-source":"examples-source","layout-locale-index-vue":"layout-locale-index-vue","layout-wireframe-index-vue":"layout-wireframe-index-vue","locale-fr-FR-json":"locale-fr-FR-json","locale-ja-json":"locale-ja-json","locale-zh-Hans-json":"locale-zh-Hans-json","views-Documentation":"views-Documentation","views-Home":"views-Home","views-Wireframes":"views-Wireframes","vuetify~examples~layout-default-index-vue~layout-home-index-vue":"vuetify~examples~layout-default-index-vue~layout-home-index-vue","vuetify~examples~layout-default-index-vue":"vuetify~examples~layout-default-index-vue","vendors~layout-default-index-vue~layout-home-index-vue":"vendors~layout-default-index-vue~layout-home-index-vue","layout-default-index-vue~layout-home-index-vue":"layout-default-index-vue~layout-home-index-vue","layout-default-index-vue":"layout-default-index-vue","vuetify~examples~layout-home-index-vue":"vuetify~examples~layout-home-index-vue","vuetify~examples":"vuetify~examples","vendors~examples":"vendors~examples","examples":"examples","layout-home-index-vue":"layout-home-index-vue","webfontloader":"webfontloader","api-en-js":"api-en-js","api-ja-js":"api-ja-js","api-zh-Hans-js":"api-zh-Hans-js","documentation-en-js":"documentation-en-js","documentation-fr-FR-js":"documentation-fr-FR-js","documentation-ja-js":"documentation-ja-js","documentation-zh-Hans-js":"documentation-zh-Hans-js","home-page-en-home-md":"home-page-en-home-md","home-page-fr-FR-home-md":"home-page-fr-FR-home-md","home-page-ja-home-md":"home-page-ja-home-md","home-page-zh-Hans-home-md":"home-page-zh-Hans-home-md","wireframes-view-en-getting-started-wireframes-md":"wireframes-view-en-getting-started-wireframes-md","wireframes-view-fr-FR-getting-started-wireframes-md":"wireframes-view-fr-FR-getting-started-wireframes-md","wireframes-view-ja-getting-started-wireframes-md":"wireframes-view-ja-getting-started-wireframes-md","wireframes-view-zh-Hans-getting-started-wireframes-md":"wireframes-view-zh-Hans-getting-started-wireframes-md","api-pages-en-pages-json":"api-pages-en-pages-json","api-pages-ja-pages-json":"api-pages-ja-pages-json","api-pages-zh-Hans-pages-json":"api-pages-zh-Hans-pages-json","locale-pages-en-pages":"locale-pages-en-pages","locale-pages-fr-FR-pages":"locale-pages-fr-FR-pages","locale-pages-ja-pages":"locale-pages-ja-pages","locale-pages-zh-Hans-pages":"locale-pages-zh-Hans-pages"}[chunkId]||chunkId) + "." + {"error-404-vue":"31d6cfe0","examples-source":"31d6cfe0","layout-locale-index-vue":"834d3d28","layout-wireframe-index-vue":"31d6cfe0","locale-fr-FR-json":"31d6cfe0","locale-ja-json":"31d6cfe0","locale-zh-Hans-json":"31d6cfe0","views-Documentation":"31d6cfe0","views-Home":"17082119","views-Wireframes":"31d6cfe0","vuetify~examples~layout-default-index-vue~layout-home-index-vue":"31d6cfe0","vuetify~examples~layout-default-index-vue":"31d6cfe0","vendors~layout-default-index-vue~layout-home-index-vue":"31d6cfe0","layout-default-index-vue~layout-home-index-vue":"b5221183","layout-default-index-vue":"72638077","vuetify~examples~layout-home-index-vue":"31d6cfe0","vuetify~examples":"31d6cfe0","vendors~examples":"31d6cfe0","examples":"195df847","layout-home-index-vue":"318ce03e","webfontloader":"31d6cfe0","api-en-js":"31d6cfe0","api-ja-js":"31d6cfe0","api-zh-Hans-js":"31d6cfe0","documentation-en-js":"31d6cfe0","documentation-fr-FR-js":"31d6cfe0","documentation-ja-js":"31d6cfe0","documentation-zh-Hans-js":"31d6cfe0","home-page-en-home-md":"31d6cfe0","home-page-fr-FR-home-md":"31d6cfe0","home-page-ja-home-md":"31d6cfe0","home-page-zh-Hans-home-md":"31d6cfe0","wireframes-view-en-getting-started-wireframes-md":"31d6cfe0","wireframes-view-fr-FR-getting-started-wireframes-md":"31d6cfe0","wireframes-view-ja-getting-started-wireframes-md":"31d6cfe0","wireframes-view-zh-Hans-getting-started-wireframes-md":"31d6cfe0","api-pages-en-pages-json":"31d6cfe0","api-pages-ja-pages-json":"31d6cfe0","api-pages-zh-Hans-pages-json":"31d6cfe0","locale-pages-en-pages":"31d6cfe0","locale-pages-fr-FR-pages":"31d6cfe0","locale-pages-ja-pages":"31d6cfe0","locale-pages-zh-Hans-pages":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"vuetify~app","vendors~app"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
